@if (organization()) {
  <div class="container-fluid p-2 p-md-3 px-0">
    <div class="row g-4">
      <div [ngClass]="hasPowerToSeeMembers() ? 'col-12 col-lg-8' : 'col-12'">
        <app-generic-card [title]="organization()!.organizationName"
                          [description]="organization()!.organizationDescription"
                          [showDescription]="!!organization()!.organizationDescription" [clampDescription]="false">

          <div card-content>
            <div class="small d-flex flex-column gap-2">
              @if (organization()!.organizationEmail) {
                <div><i class="bi bi-envelope me-2"></i>{{ organization()!.organizationEmail }}</div>
              }
              @if (organization()!.organizationPhone) {
                <div><i class="bi bi-telephone me-2"></i>{{ organization()!.organizationPhone }}</div>
              }
              @if (organization()!.organizationWebsite) {
                <div><i class="bi bi-globe me-2"></i><a href="{{ organization()!.organizationWebsite }}"
                                                        target="_blank">{{
                    organization()!.organizationWebsite
                  }}</a>
                </div>
              }
              <div><i
                class="bi bi-check-circle me-2"></i>{{ organization()!.organizationActive ? 'Attiva' : 'Inattiva' }}
              </div>

              <div class="mt-3">
                <h6 class="fw-bold">Il tuo ruolo:</h6>
                @if (organization()!.member) {
                  <div class="d-flex gap-2 flex-wrap">
                    <span class="badge bg-info">Membro</span>
                    @if (organization()!.moderator) {
                      <span class="badge bg-warning">Moderatore</span>
                    }
                    @if (organization()!.admin) {
                      <span class="badge bg-primary">Admin</span>
                    }
                    @if (organization()!.owner) {
                      <span class="badge bg-success">Proprietario</span>
                    }
                  </div>
                } @else {
                  <span class="text-muted">Non sei membro di questa organizzazione</span>
                }
              </div>
              <div>
                @if (eventMarkers().length > 0) {
                  <div class="mt-4">
                    <h6 class="fw-bold mb-2">Eventi sulla mappa</h6>
                    <app-osm-map [markers]="eventMarkers()" [compact]="true"
                                 ariaLabel="Mappa degli eventi dell'organizzazione"></app-osm-map>
                  </div>
                }
              </div>
            </div>
          </div>

          <div card-actions>
            <button class="btn btn-outline-primary btn-sm"
                    [routerLink]="canOpenEdit() ? ['/organizations/edit', organization()!.id] : null"
                    [disabled]="!canOpenEdit()" [title]="canOpenEdit() ? '' : 'Non hai i permessi per questa azione'">
              <i class="bi bi-pencil me-1"></i>Modifica
            </button>
            <button class="btn btn-outline-danger btn-sm" [disabled]="!canDelete()"
                    [title]="canDelete() ? '' : 'Non hai i permessi per questa azione'"
                    (click)="onDelete(organization()!)">
              <i class="bi bi-trash me-1"></i>Elimina
            </button>
            <button class="btn btn-secondary btn-sm me-auto" (click)="goBack()">
              <i class="bi bi-arrow-left me-1"></i>Indietro
            </button>
          </div>

        </app-generic-card>
      </div>



      @if (hasPowerToSeeMembers()) {
        <div class="col-12 col-lg-4">
          <app-generic-card title="Membri" [showTitle]="false" [showDescription]="false">
            <div card-content>
              @if (isLoadingMembers()) {
                <div class="text-center py-3">
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Caricamento...</span>
                  </div>
                </div>
              } @else if (members().length > 0) {
                <div class="d-flex flex-column gap-2">
                  @for (member of members(); track member.userId) {
                    <div class="d-flex align-items-center gap-2 p-2 border rounded">
                      <div
                        class="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white fw-bold"
                        style="width: 32px; height: 32px; font-size: 12px;">
                        {{ member.userName?.charAt(0) || '?' }}
                      </div>
                      <div class="flex-grow-1">
                        <div class="fw-bold small">{{ member.userName || 'Utente #' + member.userId }}</div>
                        <div class="text-muted" style="font-size: 11px;">{{ member.userEmail || '' }}</div>
                      </div>
                      <span class="badge" [ngClass]="getRoleBadgeClass(member.organizationRole)">
                {{ member.organizationRole || 'MEMBER' }}
              </span>
                    </div>
                  }
                </div>
              } @else {
                <div class="text-center text-muted py-4">
                  <i class="bi bi-people fs-1"></i>
                  <p class="mt-2 mb-0">Nessun membro trovato</p>
                </div>
              }
            </div>
          </app-generic-card>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="container-fluid p-2 p-md-3 px-0 text-center">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Caricamento...</span>
    </div>
  </div>
}
